package com.iptvplayer.shared.data.remote

import com.iptvplayer.shared.data.local.preferences.TokenStorage
import com.iptvplayer.shared.util.Constants
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.api.createClientPlugin
import io.ktor.http.URLBuilder
import io.ktor.http.takeFrom

/**
 * On the web, rewrite any request to a non-backend host (i.e. an IPTV panel)
 * into a same-origin call to the backend proxy:
 *   http://panel/...  ->  {BASE_URL}/api/proxy?url=<original>&token=<access>
 * so the HTTPS page isn't blocked by the browser's mixed-content policy.
 */
actual fun HttpClientConfig<*>.configurePlatformProxy(tokenStorage: TokenStorage) {
    val backendHost = URLBuilder().takeFrom(Constants.BASE_URL).host

    install(createClientPlugin("WebMixedContentProxy") {
        onRequest { request, _ ->
            val host = request.url.host
            val scheme = request.url.protocol.name
            if (host.isNotBlank() && host != backendHost && (scheme == "http" || scheme == "https")) {
                val original = request.url.buildString()
                val token = tokenStorage.getToken()?.accessToken ?: ""
                request.url.takeFrom("${Constants.BASE_URL}/api/proxy")
                request.url.parameters.clear()
                request.url.parameters.append("url", original)
                request.url.parameters.append("token", token)
            }
        }
    })
}
